<div class="py-4 px-4 sm:px-[4.5rem] bg-white border-t border-gray-200">
  <nav class="flex flex-row items-center justify-between">

    <button
      *ngIf="!HidePrevious"
      type="button"
      [disabled]="PreviousDisabled"
      class="btn-text flex flex-row items-center gap-2"
      (click)="PreviousButton()"
    >
      <i class="icon-arrow-left"></i>
      <span class="hidden sm:inline">Προηγούμενο</span>
    </button>

    <div class="flex-1"></div>

    <button
      *ngIf="!HideNext"
      type="button"
      [disabled]="NextDisabled"
      class="btn-primary disabled:border-gray-100 flex flex-row items-center gap-2 sm:min-w-[135px]"
      (click)="NextButton()"
    >
    @if (loading) {
      <app-loader [withBackground]="false" variant="primary" [width]="25"></app-loader>
    } @else {
      <span class="hidden sm:inline ">Επόμενο</span>
      <i class="icon-arrow-right"></i>
    }
    </button>
  </nav>
</div>


